import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "@/components/AuthShell";
import { api, formatErr } from "@/lib/api";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { setError(formatErr(err)); }
    finally { setBusy(false); }
  };
  return (
    <AuthShell eyebrow="Password reset" title="Forgot password" subtitle="We'll email you a secure link to set a new one.">
      {sent ? (
        <div className="panel p-6" data-testid="forgot-password-sent">
          <p className="text-sm">If an account exists for <span className="text-[#9C4DDC]">{email}</span>, a reset link is on its way. It expires in 1 hour.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div><label className="label">Email</label>
            <input className="field" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@studio.com" data-testid="forgot-password-email-input" /></div>
          {error && <p className="text-sm text-red-400" data-testid="forgot-password-error">{error}</p>}
          <button className="btn-primary w-full" disabled={busy} data-testid="forgot-password-submit-button">{busy ? "Sending…" : "Send reset link"}</button>
        </form>
      )}
      <p className="text-sm muted mt-8"><Link to="/login" className="text-[#9C4DDC]" data-testid="forgot-password-back-link">Back to sign in</Link></p>
    </AuthShell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password: pw });
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (err) { setError(formatErr(err)); }
    finally { setBusy(false); }
  };
  return (
    <AuthShell eyebrow="Password reset" title="Set a new password">
      <form onSubmit={submit} className="space-y-5">
        <div><label className="label">New password</label>
          <input className="field" type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} placeholder="At least 6 characters" data-testid="reset-password-input" /></div>
        {error && <p className="text-sm text-red-400" data-testid="reset-password-error">{error}</p>}
        <button className="btn-primary w-full" disabled={busy} data-testid="reset-password-submit-button">{busy ? "Saving…" : "Update password"}</button>
      </form>
    </AuthShell>
  );
}
